export default __webpack_public_path__ + "static/media/KallinKhan.8068d4f1.jpg";